import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { useEffect, useState } from "react";
import api, { VendorDto } from "../../../api";
import { notif } from "../../utils/util";

export type VendorListProps = {
  vendorId?: string;
  onChange?: (vendorId: string) => void;
};

export const VendorList = (props: VendorListProps) => {
  const { vendorId, onChange} = props;

  const [items, setItems] = useState<VendorDto[]>([]);
  const [selected, setSelected] = useState(vendorId ?? "");

  const load = async () => {
    try {
      const result = await api.vendor.find({ size: 99999 } as any);
      setItems(result.data);
    } catch (err: any) {
      notif(err, "error");
    }
  };
  const handleChange = (value: string) => {
    setSelected(value);
    if (onChange) onChange(value);
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <FormControl sx={{ minWidth: 200 }}>
      <InputLabel id="vendor-list-label">Vendor</InputLabel>
      <Select labelId="vendor-list-label" label="Vendor" value={selected} onChange={(e) => handleChange(e.target.value)}>
        {items?.map((item) => {
          return (
            <MenuItem value={item?.id} key={item?.id}>
              {item?.name}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};
